import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {UserAuthenticationService} from '../services/user-authentication.service';

export class TenantHeaderInterceptor implements HttpInterceptor {
    private readonly userAuthService = inject(UserAuthenticationService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!!request.headers.get('X-Tenant')) {
            return next.handle(request);
        }

        const tenantId = this.userAuthService.currentUserInfo?.mandantID;
        if (!tenantId) {
            return next.handle(request);
        }

        request = request.clone({
            setHeaders: {
                'X-Tenant': tenantId,
            },
        });

        return next.handle(request);
    }
}
